import styled from "styled-components";

export const TopCitiesTitle = styled.h2`
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.secondary};
`;
